module.exports = _.extend({
  initialize: function () {
  },

  _load: async function () {
    const appNode = document.createElement('div');
    appNode.id = 'snackbar';
    appNode.setAttribute('aurelia-app', 'snackbar/main');
    document.querySelector('body').appendChild(appNode);

    await INKIVE.Helpers.getAureliaLibraries($(appNode));

    const { adapter } = await System.import('@desygner/adapter/adapter');
    this._snackbarApp = adapter.getAdapterByDomElement(appNode);
    await new Promise(resolve => INKIVE.Helpers.afterRendering(resolve));
  },

  load: async function () {
    INKIVE.C.IS_MOBILE || await (this._loadingPromise = this._loadingPromise || this._load());
  },

  display: function ({ fileName, step, hold, total }) {
    this._snackbarApp && this._snackbarApp.invoke('toggle', { fileName, step, hold, total });
  }

}, Backbone.Events);
